import React, { useState, useEffect } from 'react';
import { db } from "./firebase";
import './Orders.css';
import Order from './Order';
import { useStateValue } from './StateProvider';
import { collection, doc, query, orderBy, limit, onSnapshot } from "firebase/firestore";

function Orders() {
  const [{ basket, user }] = useStateValue();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribe;

    if (user) {
      // Referenza alla collezione 'orders' dell'utente
      const ordersRef = collection(db, 'users', user.uid, 'orders');

      // Query: ordina per campo 'created' discendente, limita a 5
      const q = query(ordersRef, orderBy('created', 'desc'), limit(5));

      unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          setOrders(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          );
          setLoading(false);
        },
        (error) => {
          console.error("Errore nel caricamento degli ordini:", error);
          setLoading(false);
        }
      );
    } else {
      // se non sei loggato
      setOrders([]);
      setLoading(false);
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [user]);

  if (loading) {
    return (
      <div className="orders">
        <p>Caricamento ordini...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="orders">
        <h2>I tuoi ordini</h2>
        <p className="orders_message">
          Non sei autenticato. Accedi per vedere i tuoi ordini.
        </p>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="orders">
        <h2>I tuoi ordini</h2>
        <p className="orders_message">Non hai ancora effettuato ordini.</p>
      </div>
    );
  }

  return (
    <div className="orders">
      <h2>I tuoi ultimi 5 ordini</h2>
      <div className="orders_list">
        {orders.map((order) => (
          <Order key={order.id} order={order} />
        ))}
      </div>
    </div>
  );
}

export default Orders;
